import axios from 'axios';
import routes from 'app/routes';

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.resource_categories.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', categories: resp.data.data });
      });
  },
  add: (dispatch, values, callback) => {
    axios
      .post(routes.api.resource_categories.create, values)
      .then((resp) => {
        dispatch({ type: 'ADD', category: resp.data.data });
        callback();
      });
  },
  update: (dispatch, categoryId, values, callback) => {
    axios
      .put(routes.api.resource_categories.update(categoryId), values)
      .then((resp) => {
        dispatch({ type: 'UPDATE', category: resp.data.data });
        callback();
      });
  },
  delete: (dispatch, categoryId) => {
    axios.delete(routes.api.resource_categories.destroy(categoryId)).then(() => {
      dispatch({
        type: 'DELETE',
        categoryId,
      });
    });
  },
};
